var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('app-dasboard'),_c('div',{staticClass:"main-panel",attrs:{"id":"main-panel"}},[_c('app-header'),_c('router-view'),_c('app-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }